






import { Component, Vue } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class FormHeader extends Vue {

  nClick(){
    this.$emit('nClick')
  }

}
